import { motion } from "framer-motion";
import { Star } from "lucide-react";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden pt-36 pb-20 sm:pt-44 sm:pb-28">
      {/* glow */}
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute left-1/2 top-10 h-[420px] w-[420px] -translate-x-1/2 rounded-full bg-[#98D8BA] opacity-40 blur-[120px] animate-float-slow" />
        <div className="absolute right-10 top-40 h-[280px] w-[280px] rounded-full bg-[#75C69F] opacity-25 blur-[120px]" />
      </div>

      <div className="mx-auto max-w-6xl px-6 sm:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          className="mx-auto max-w-3xl text-center"
        >
          <span
            className="inline-flex items-center gap-2 rounded-full bg-[#F0F5F2] px-4 py-1.5 text-xs font-bold uppercase tracking-[0.18em] text-[#0B281B]"
            data-testid="hero-badge"
          >
            <Star className="h-3.5 w-3.5 fill-[#75C69F] text-[#75C69F]" />
            For micro & small businesses
          </span>

          <h1 className="mt-7 font-heading text-5xl font-medium leading-[1.05] tracking-tight text-[#0B281B] sm:text-6xl lg:text-7xl">
            Big presence for{" "}
            <span className="relative whitespace-nowrap">
              small business
              <svg
                className="absolute -bottom-2 left-0 w-full"
                viewBox="0 0 300 12"
                fill="none"
                preserveAspectRatio="none"
              >
                <path
                  d="M2 9C75 3 150 3 298 7"
                  stroke="#98D8BA"
                  strokeWidth="5"
                  strokeLinecap="round"
                />
              </svg>
            </span>
            .
          </h1>

          <p className="mx-auto mt-7 max-w-xl text-lg leading-relaxed text-[#4A6657]">
            Sprig Built gets your business online — a polished website, Google
            profile, and branding — without the agency price tag or the tech
            headaches.
          </p>

          <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href="#pricing"
              data-testid="hero-secondary-cta"
              className="inline-flex items-center justify-center rounded-full border-2 border-[#0B281B] px-8 py-4 font-medium text-[#0B281B] transition-colors hover:bg-[#0B281B] hover:text-white"
            >
              See pricing
            </a>
          </div>

          <p className="mt-6 text-sm text-[#4A6657]">
            100% remote — work with us from anywhere. Launch in as little as 7 days.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.25, ease: "easeOut" }}
          className="mx-auto mt-16 grid max-w-4xl grid-cols-2 gap-4 sm:grid-cols-4"
          data-testid="hero-stats"
        >
          {[
            { k: "7 days", v: "Avg. launch time" },
            { k: "$299", v: "Starting price" },
            { k: "100%", v: "Mobile-ready" },
            { k: "1:1", v: "Personal support" },
          ].map((s) => (
            <div
              key={s.v}
              className="rounded-2xl border border-[#DCECE3] bg-white/70 px-4 py-5 text-center backdrop-blur"
            >
              <p className="font-heading text-2xl font-bold text-[#0B281B]">{s.k}</p>
              <p className="mt-1 text-xs text-[#4A6657]">{s.v}</p>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
